import {
  FETCH_CHEMISTORDERDETAILS_SUCCESS_ACTION,
  // FETCH_CHEMISTORDERVIEW_INIT_ACTION,
  FETCH_CHEMISTORDERVIEW_SUCCESS_ACTION,
  EDIT_ITEMDETAILS_SUCCESS_ACTION,
  FETCH_CHEMISTINPROGRESSORDER_SUCCESS_ACTION,
  FETCH_CHEMISTCOMPLETEDORDER_SUCCESS_ACTION,
  FETCH_CHEMISTCANCELLEDORDER_SUCCESS_ACTION,
  FETCH_DELIVERYSTATUS_SUCCESS_ACTION,
  GET_COMPLETEITEMSURGENT_SUCCESS_ACTION,
  SEARCH_CHEMISTORDERVIEW_SUCCESS_ACTION,
} from './action';

const initialState = {
  processing: false,
  error: false,
};

export default function(state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_CHEMISTORDERDETAILS_SUCCESS_ACTION:
      return {
        ...state,
        chemistOrderDetails: action.payload.rows,
        chemistOrdersCount: action.payload.count,
      };

    case FETCH_CHEMISTINPROGRESSORDER_SUCCESS_ACTION:
      return {
        ...state,
        chemistinprogressOrderDetails: action.payload.rows,
        chemistinprogressOrderCount: action.payload.count,
      };
    case FETCH_CHEMISTCOMPLETEDORDER_SUCCESS_ACTION:
      return {
        ...state,
        chemistcompleteOrderDetails: action.payload.rows,
        chemistcompleteOrderCount: action.payload.count,
      };

    case FETCH_CHEMISTCANCELLEDORDER_SUCCESS_ACTION:
      return {
        ...state,
        chemistcancelledOrderDetails: action.payload.rows,
        chemistcancelledOrderCount: action.payload.count,
      };

    case FETCH_CHEMISTORDERVIEW_SUCCESS_ACTION:
      return {
        ...state,
        chemistOrderDtls: action.payload.rows,
        chemistOrderDtlsCount: action.payload.count,
      };
    case EDIT_ITEMDETAILS_SUCCESS_ACTION:
      return {
        ...state,
        chemistOrderDtls: state.chemistOrderDtls.map(
          orders => (orders.id === action.payload.id ? action.payload : orders)
        ),
      };
    case FETCH_DELIVERYSTATUS_SUCCESS_ACTION:
      return {
        ...state,
        deliverystatusList: action.payload.rows,
      };

    case GET_COMPLETEITEMSURGENT_SUCCESS_ACTION:
      return {
        ...state,
        completeitemDetails: action.payload.rows,
        completeitemDetailsCount: action.payload.count,
      };

    case SEARCH_CHEMISTORDERVIEW_SUCCESS_ACTION:
      return {
        ...state,
        chemistOrderSearchList: action.payload.rows,
        chemistOrderSearchCount: action.payload.count,
      };

    default:
      return {
        ...state,
      };
  }
}
